<template>
  <div class="col-lg-12">
    <Breadcrumbs class="tw-mb-0" />
    <ul class="nav nav-tabs nav tabs-bordered" role="tablist">
      <li :class="{ active: currentPage.includes('region/settings') }">
        <router-link
          to="/region/settings"
          data-toggle="tab"
          data-test="region-tab-settings"
          role="tab"
        >
          <span>{{ trans("center.groupMenuLabelGeneral") }}</span>
        </router-link>
      </li>
      <li :class="{ active: currentPage.includes('centers') }">
        <router-link
          to="/region/centers"
          data-toggle="tab"
          data-test="region-tab-centers"
          role="tab"
        >
          <span>{{ trans("admin.centers") }}</span>
        </router-link>
      </li>
      <li :class="{ active: currentPage.includes('patients') }">
        <router-link
          to="/region/patients"
          data-toggle="tab"
          data-test="region-tab-patients"
          role="tab"
        >
          <span>{{ trans("admin.patients") }}</span>
        </router-link>
      </li>
      <li :class="{ active: currentPage.includes('export') }">
        <router-link
          to="/region/export"
          data-toggle="tab"
          data-test="region-tab-export"
          role="tab"
        >
          <span>{{ trans("center.centerExport") }}</span>
        </router-link>
      </li>
      <li :class="{ active: currentPage.includes('region/cdr') }">
        <router-link
          to="/region/cdr"
          data-toggle="tab"
          data-test="region-tab-cdr"
          role="tab"
        >
          <span>{{ trans("admin.cdr.title") }}</span>
        </router-link>
      </li>
    </ul>

    <router-view />
  </div>
</template>

<script>
import Breadcrumbs from "../Utils/Breadcrumbs.vue";

export default {
  components: { Breadcrumbs },
  computed: {
    currentPage: function () {
      return this.$route.path;
    },
  },
};
</script>
